import Alpine from 'alpinejs';
import component from 'alpinejs-component';
import './account_controller';
import './account_collection_controller';
import './automation_contact_controller';
import './automation_flow_controller';
import './caption_controller';
import './collection_controller';
import './competitor_controller';
import './hashtag_controller';
import './slayer_controller';
import './strategy_profile_controller';


Alpine.plugin(component);
Alpine.start();


